<template>
  <div class="courses-list">
    <template v-if="groupedCoursesByLocale.length > 1">
      <!-- Если есть курсы разных локалей - показываем секциями -->
      <div v-for="group in groupedCoursesByLocale"
           :key="group.locale || 'unknown'"
           class="courses-locale-section">
        <h2 class="locale-section-title">
          {{ group.localeLabel }}
        </h2>
        <div class="courses-grid">
          <CourseCard
            v-for="course in group.courses"
            :key="course.id"
            :course="course"
            :locale="locale"
            :category="category"
          />
        </div>
      </div>
    </template>
    <template v-else>
      <!-- Если все курсы одной локали - показываем без секций -->
      <div class="courses-grid">
        <CourseCard
          v-for="course in courses"
          :key="course.id"
          :course="course"
          :locale="locale"
          :category="category"
        />
      </div>
    </template>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { groupCoursesByLocale } from '@/utils/course'
import type { Course } from '@/domain/entities/course.entity'

const { t } = useI18n()

const props = defineProps<{
  courses: Course[]
  locale: string
  category?: string
}>()

// Группируем курсы по локалям
const groupedCoursesByLocale = computed(() => {
  return groupCoursesByLocale(props.courses, () => 
    t('courseCategory.courses.unknownLocale', 'Інші мови')
  )
})
</script>

<style scoped>
.courses-list {
  width: 100%;
  max-width: var(--max-width-container);
  margin: 0 auto;
}

.courses-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 25px;
  margin-bottom: 2rem;
  min-width: 0;
}

@media (max-width: 1024px) {
  .courses-grid {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
}

@media (max-width: 768px) {
  .courses-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 480px) {
  .courses-grid {
    grid-template-columns: minmax(0, 1fr);
  }
}

.courses-locale-section {
  margin-bottom: 4rem;
}

.courses-locale-section:last-child {
  margin-bottom: 0;
}

.locale-section-title {
  font-family: var(--font-inter);
  font-size: 24px;
  font-weight: 500;
  color: #252840;
  margin-bottom: 2rem;
  text-align: left;
}
</style>
